export default __webpack_public_path__ + "static/media/walmart-logo.ac7225a9.png";